import { Documento, ISdocumento } from "../../processo/Documento";
import { ISprocesso, Processo } from "../../processo/Processo";
import { ISusuarioList, UsuarioList } from "../../usuario/UsuarioList";

export interface DocumentoVersao {
  id: string;
  conteudo: string;
  usuario: UsuarioList;
  dataHoraCriacao: Date | null;
}

export const ISdocumentoVersao: DocumentoVersao = {
  id: "",
  conteudo: "",
  usuario: ISusuarioList,
  dataHoraCriacao: null,
};
